import React, { ReactNode } from 'react'
import { Colors } from '../../constants'
import styled from 'styled-components'
import { TopBar } from '../topBar'
import { Footer } from '../footer'
import { Canvas } from './Canvas'
import { Banner } from '../Banner'
import { MaintenanceBanner } from '../TemporaryBanners'

interface Props {
  children: ReactNode
}

export function Page({ children }: Props) {
  return (
    <>
      <Container>
        <CanvasStyled />
        <TopBar />
        <Banner />
        <MaintenanceBanner />
        {children}
      </Container>
      <Footer />
    </>
  )
}

const Container = styled.div`
  padding: 0 0 60px 0;
  position: relative;
  min-height: 100vh;
  background-color: ${Colors.Background};

  @media (max-width: 1024px) {
    padding-bottom: 130px;
  }
`

const CanvasStyled = styled(Canvas)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
`
